/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_SubtitleInputs */



/**
* | output |
* | --- |
* | "Browse and edit the data tables in your spaces." |
*
* @param {Datasets_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_subtitle = /** @type {((inputs?: Datasets_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Durchsuchen und bearbeiten Sie die Datentabellen in Ihren Bereichen.")
	return /** @type {LocalizedString} */ ("Browse and edit the data tables in your spaces.")
});